<template>
  <!-- 导出国家级视频公开课在线精品课报告 -->
  <div class="analysisReport">
    <el-button type="primary" class="export" @click="exportPdf">导出pdf</el-button>
    <div class="analysisReport_box" ref="pdfContent">
      <span v-show="false">这是completeNum的值：{{ completeNum }}</span>
      <input id="completeNum" v-model="completeNum" v-show="false" />
      <!-- PDF  首页 -->
      <div class="HomePage page-box">
        <div id="image"></div>
        <div id="PdfTitle">
          <p id="FristTitle">职业教育在线精品课和视频公开课</p>
          <div>
            <p id="SecondTitle">建设及应用监测{{ detailTime }}分析报告</p>
          </div>
          <p id="ThrendTitle">（{{ nowYear }}年{{ Quarter }}）</p>
          <p id="FourTitle">运行分析起止时间：{{ startDay }} 至 {{ endDay }}</p>
        </div>

        <!-- 底部 -->
        <div id="foot">
          <div class="footBox">
            <p>国家职业教育智慧教育平台专业与课程服务中心监测平台项目组</p>
            <p>广东轻工职业技术学院产教融合大数据研究所</p>
            <p>
              <span v-if="nowMonth != '12'">{{ nowYear }}年</span>
              <span v-else>{{ +nowYear + 1 }}年</span>
              <span v-if="nowMonth != '12'">{{ +nowMonth + 1 }}</span
              ><span v-else>1</span> 月 10 日
            </p>
          </div>
        </div>
      </div>

      <!-- 目录 -->
      <div class="catalogue page-box">
        <div class="title">
          <h3>目&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;录</h3>
        </div>
        <h5>1. 监测总览<span class="dot"></span>1</h5>
        <h5 class="Second_text">1.1 总体建设及应用情况<span class="dot"></span>1</h5>
        <div class="Thred_text">
          <h5>1.1.1 建设课程情况<span class="dot"></span>1</h5>
          <h5>1.1.2 课程访问情况<span class="dot"></span>2</h5>
          <h5>1.1.3 课程选课情况<span class="dot"></span>3</h5>
          <h5>1.1.4 课程互动情况<span class="dot"></span>4</h5>
        </div>
        <h5 class="Second_text">
          1.2 {{ startDay }}至{{ endDay }}运行监测分析<span class="dot"></span>5
        </h5>
        <h5>2. 在线精品课建设及应用情况<span class="dot"></span>6</h5>
        <h5 class="Second_text">2.1 在线精品课建设情况<span class="dot"></span>6</h5>
        <h5 class="Second_text">2.2 在线精品课访问情况<span class="dot"></span>7</h5>
        <h5 class="Second_text">2.3 在线精品课开课情况<span class="dot"></span>8</h5>
        <h5 class="Second_text">2.4 在线精品课程选课情况<span class="dot"></span>8</h5>
        <h5>3. 视频公开课建设及应用情况<span class="dot"></span>9</h5>
        <h5 class="Second_text">3.1 视频公开课建设情况<span class="dot"></span>9</h5>
        <h5 class="Second_text">3.2 视频公开课访问情况<span class="dot"></span>10</h5>
        <h5 class="Second_text">3.3 视频公开课选课情况<span class="dot"></span>10</h5>
      </div>

      <!-- 第一页 -->
      <div class="chart_box page-box" style="padding-top: 5%">
        <div class="header_titles">
          <h1>国家职业教育智慧教育平台专业与课程服务中心</h1>
          <h1 style="margin-top: 15px">（在线精品课和视频公开课）</h1>
          <h1 style="margin-top: 15px">{{ nowYear }}年{{ Quarter }}建设及应用监测分析报告</h1>
          <div class="number_time">
            <div>
              <span></span>
              <span>统计时间：{{ startDay }} 至 {{ endDay }}</span>
            </div>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="division">1. 监测总览</div>
        <p>
          自2022年3月28日开始，国家职业教育智慧教育平台专业与课程服务中心上线，专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对在线精品课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，监测平台共接入在线精品课{{
            courseTotal.onlineBoutique
          }}门，视频公开课{{ courseTotal.openVedio }}门，覆盖平台数{{
            platformNum.onlineCourseAddvideoCourse
          }}个（包括国家级在线精品课和视频公开课支撑平台）。在线精品课和视频公开课累计用户访问量达{{
            getUtils_Fun(BoutiAndque.totalVisitNum.value)
          }}；参与建设的院校有{{ BoutiAndque.schoolNum.value }}所，教师{{
            getUtils_Fun(BoutiAndque.tearchNum.value)
          }}名。
        </p>
        <h4>1.1 总体建设及应用分析</h4>
        <h5>1.1.1 建设课程情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程总计{{
            getUtils_Fun(courseType.onlineQualitr.value + courseType.videOpen.value)
          }}门，其中在线精品课{{ courseType.onlineQualitr.value }}门，视频公开课{{
            courseType.videOpen.value
          }}门，其占比分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="courseType.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'32%'"
            :legendBackgroundColor="true"
            :legendLeft="'60%'"
            :circleSize="80"
          ></circularChart>
        </div>
        <div class="chart_name">图1 课程来源分布</div>
      </div>

      <div class="chart_box page-box">
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，建设课程数最多的是{{
            courseRankTable.Max.province
          }}省，共{{
            courseRankTable.Max.total
          }}门。具体各省份参与建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表1 各省份建设课程数量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>在线精品课数（门）</th>
              <th>视频公开课数（门）</th>
              <th>课程总数（门）</th>
            </tr>

            <tr
              v-for="(item, index) in courseRankTable.dataList"
              :key="index"
              v-show="courseRankTable.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.online }}</td>
              <td>{{ item.open }}</td>
              <td>{{ item.total }}</td>
            </tr>
            <tr v-show="courseRankTable.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，参与建设课程的教师累计{{
            getUtils_Fun(BoutiAndque.tearchNum.value)
          }}名，主要分布在{{ courseNum.Frist.name }}省，其次在{{
            courseNum.Second.name
          }}省。具体各省份参与建设的教师数量排名（前十五名）如下表所示：
        </p>
        <div class="standards_content echartsHeight">
          <tcolumnarChart
            :isExportTextColor="true"
            :isShowTextColor="true"
            :refId="'coursesOfferedChart'"
            :datas="courseNum.dataList"
            :transverseData="courseNum.transverseData"
            :colorList="colorList"
          ></tcolumnarChart>
        </div>
        <div class="chart_name">图2 各省份参与建设教师数量排名（前十五名）</div>
      </div>

      <!-- 第二页 -->
      <div class="chart_box page-box">
        <h5>1.1.2 课程访问情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，总访问量为{{
            getUtils_Fun(BoutiAndque.totalVisitNum.value)
          }}次，其中在线精品课{{ getUtils_Fun(onlineBoutique.totalVisitNum.value) }}次，视频公开课{{
            getUtils_Fun(vediOpen.totalVisitNum.value)
          }}次。在线精品课《{{ courseRankall.Max.courseName }}》的访问量最多，共{{
            getUtils_Fun(courseRankall.Max.courseTotalVisit)
          }}次。具体课程访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表2 课程访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程来源</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in courseRankall.dataList"
              :key="index"
              v-show="courseRankall.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.courseName }}</td>
              <td>{{ item.courseType }}</td>
              <td>{{ item.majorTeacher }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ item.courseTotalVisit }}</td>
            </tr>
            <tr v-show="courseRankall.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
            provinceVisitRank.Max.province
          }}省的课程访问量最多。具体各省份的课程总访问量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表3 各省课程访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>在线精品课访问量（次）</th>
              <th>视频公开课访问量（次）</th>
              <th>课程总访问量（次）</th>
            </tr>

            <tr
              v-for="(item, index) in provinceVisitRank.dataList"
              :key="index"
              v-show="provinceVisitRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total1 }}</td>
              <td>{{ item.total2 }}</td>
              <td>{{ item.total }}</td>
            </tr>
            <tr v-show="provinceVisitRank.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第三页 -->
      <div class="chart_box page-box">
        <h5>1.1.3 课程选课情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，选课人数总计{{
            getUtils_Fun(BoutiAndque.selectedCourses.value)
          }}人，在线精品课{{ getUtils_Fun(onlineBoutique.selectedCourses.value) }}人，视频公开课{{
            getUtils_Fun(vediOpen.selectedCourses.value)
          }}人。其中在线精品课《{{ courseStudyRank.Max.courseName }}》的选课人数最多，共{{
            getUtils_Fun(courseStudyRank.Max.studyNum)
          }}人。具体课程选课人数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表4 课程选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程来源</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>选课人数（人）</th>
            </tr>

            <tr
              v-for="(item, index) in courseStudyRank.dataList"
              :key="index"
              v-show="courseStudyRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.courseName }}</td>
              <td>{{ item.courseType }}</td>
              <td>{{ item.majorTeacher }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ parseInt(item.studyNum) }}</td>
            </tr>
            <tr v-show="courseStudyRank.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
            provinceStudyRank.Max.province
          }}省的课程选课人数最多，共{{
            getUtils_Fun(provinceStudyRank.Max.total)
          }}人。具体各省份课程总选课人数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表5 各省课程选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>在线精品课选课人数（人）</th>
              <th>视频公开课选课人数（人）</th>
              <th>总选课人数（人）</th>
            </tr>

            <tr
              v-for="(item, index) in provinceStudyRank.dataList"
              :key="index"
              v-show="provinceStudyRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total1 }}</td>
              <td>{{ item.total2 }}</td>
              <td>{{ item.total }}</td>
            </tr>
            <tr v-show="provinceStudyRank.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第四页 -->
      <div class="chart_box page-box">
        <h5>1.1.4 课程互动情况</h5>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程互动总计{{
            getUtils_Fun(BoutiAndque.interactionsTotal.value)
          }}次，在线精品课{{ getUtils_Fun(onlineBoutique.interactionsTotal.value) }}次，视频公开课{{
            getUtils_Fun(vediOpen.interactionsTotal.value)
          }}次，在线精品课《{{ courseSemesterRank.Max.courseName }}》的互动次数最多，共{{
            getUtils_Fun(courseSemesterRank.Max.sumInteractNum)
          }}次。具体课程互动数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表6 课程互动数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程名称</th>
              <th>课程来源</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>互动数（次）</th>
            </tr>

            <tr
              v-for="(item, index) in courseSemesterRank.dataList"
              :key="index"
              v-show="courseSemesterRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.courseName }}</td>
              <td>{{ item.courseType }}</td>
              <td>{{ item.majorTeacher }}</td>
              <td>{{ item.schoolName }}</td>
              <td>{{ parseInt(item.sumInteractNum) }}</td>
            </tr>
            <tr v-show="courseSemesterRank.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top150">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
            provinceSemesterRank.Max.province
          }}省的课程互动数最多。共{{
            getUtils_Fun(provinceSemesterRank.Max.total)
          }}次，具体各省份的课程总互动数排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表7 各省课程互动数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>在线精品课互动数（次）</th>
              <th>视频公开课互动数（次）</th>
              <th>总互动数（次）</th>
            </tr>
            <tr
              v-for="(item, index) in provinceSemesterRank.dataList"
              :key="index"
              v-show="provinceSemesterRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total1 }}</td>
              <td>{{ item.total2 }}</td>
              <td>{{ item.total }}</td>
            </tr>
            <tr v-show="provinceSemesterRank.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第五页 -->
      <div class="chart_box page-box">
        <h4>1.2 {{ startDay }} 至 {{ endDay }}运行监测分析</h4>
        <p>
          在分析时间内，课程新增访问量{{
            getUtils_Fun(selectCourseOnlineVisit.VisitTotal + selectCourseVediOpenVisit.VisitTotal)
          }}次，其中在线精品课{{ getUtils_Fun(selectCourseOnlineVisit.VisitTotal) }}次，视频公开课{{
            getUtils_Fun(selectCourseVediOpenVisit.VisitTotal)
          }}次。新增访问量趋势图如下所示：
        </p>
        <div class="standards_content echartsHeight" style="width: 95%">
          <discountChart
            :refId="'typeDistributionChart'"
            :isExportTextColor="true"
            :isShowTextColor="true"
            :datas="SelectVisitData.dataList"
            :transverseData="SelectVisitData.transverseData"
            :colorList="colorList"
            :legendList="SelectVisitData.legendList"
            :isaverage="true"
            :innerText="'单位：次'"
          >
          </discountChart>
        </div>
        <div class="chart_name">图3 {{ startDay }} 至 {{ endDay }} 课程新增访问量趋势图</div>
      </div>

      <!-- 第六页 -->
      <div class="chart_box page-box">
        <div class="division">2. 在线精品课建设及应用情况</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，在线精品课共纳入监测{{
            getUtils_Fun(courseTotal.onlineBoutique)
          }}门，其中，国家级课程有{{ ByLevel.SecArr.value }}门，省级课程有{{
            ByLevel.FristArr.value
          }}门，校级课程有{{ ByLevel.ThrArr.value }}门，目前，在线精品课程已有{{
            onlineBoutique.schoolNum.value
          }}所院校和{{
            getUtils_Fun(onlineBoutique.tearchNum.value)
          }}名教师参与建设与应用，总访问量达{{
            getUtils_Fun(onlineBoutique.totalVisitNum.value)
          }}次，总开课期数为{{ getUtils_Fun(onlineBoutique.startsCourses.value) }}期，总课时数为{{
            getUtils_Fun(onlineBoutique.classHour.value)
          }}课时，总选课人数{{ getUtils_Fun(onlineBoutique.selectedCourses.value) }}人，总互动次数{{
            getUtils_Fun(onlineBoutique.interactionsTotal.value)
          }}次。具体建设及应用情况如下：
        </p>
        <h4>2.1 在线精品课建设情况</h4>
        <p>1. 各省建设在线精品课数量分布情况</p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，{{
            getonlineCreateRank.Max.name
          }}省参与建设课程数量最多，共{{
            getonlineCreateRank.Max.value
          }}门，各省建设在线精品课数量分布情况如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="getonlineCreateRank.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'15%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :seriesRight="'70%'"
            :showValue="true"
            :unit="'门'"
            :legendLeft="'30%'"
          ></circularChart>
        </div>
        <div class="chart_name">图4 各省建设在线精品课数量分布情况</div>

        <p class="m-top150">
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课建设共纳入监测{{
            courseTotal.onlineBoutique
          }}门，其中，{{ changeCity(couseRank.MaxArr.province) }}建设课程数量最多，共{{
            couseRank.MaxArr.total
          }}门，具体各省建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表8 各省建设在线精品课程数量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>建设课程数</th>
              <th>选课人数</th>
            </tr>

            <tr
              v-for="(item, index) in couseRank.dataList.slice(0, 15)"
              :key="index"
              v-show="couseRank.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total }}</td>
              <td>{{ item.studynum }}</td>
            </tr>
            <tr v-show="couseRank.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第七页 -->
      <div class="chart_box page-box">
        <p>2. 归属专业大类分布</p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程覆盖{{
            onlineCourseCategory.dataList.length - 1
          }}个专业大类。从专业大类分布看，{{ onlineCourseCategory.Max.name }}的课程最多，一共{{
            onlineCourseCategory.Max.value
          }}门课程，占比达{{
            ((onlineCourseCategory.Max.value / onlineCourseCategory.total) * 100).toFixed(2)
          }}%，具体可归属专业大类的在线精品课分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="onlineCourseCategory.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'15%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :seriesRight="'70%'"
            :showValue="true"
            :unit="'门'"
            :legendLeft="'30%'"
          ></circularChart>
        </div>
        <div class="chart_name">图5 在线精品课专业大类分布情况</div>
        <h4 class="m-top150">2.2 在线精品课访问情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计访问量{{
            getUtils_Fun(onlineBoutique.totalVisitNum.value)
          }}，访问量最高的课程是{{ couseAll.MaxArr.schoolname }}的《{{
            couseAll.MaxArr.name
          }}》，访问量排名（前十五名）的课程信息如下：
        </p>
        <div class="chart_name">表9 在线精品课访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in couseAll.dataList"
              :key="index"
              v-show="couseAll.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="couseAll.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第八页 -->
      <div class="chart_box page-box">
        <h4>2.3 在线精品课开课情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计开课期数{{
            getUtils_Fun(onlineBoutique.startsCourses.value)
          }}期，开课期数最多的课程是{{ couseOpen.MaxArr.schoolname }}的《{{
            couseOpen.MaxArr.name
          }}》，开课期数（前十五名）的课程信息如下：
        </p>
        <div class="chart_name">表10 在线精品课开课期数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>开课期数</th>
            </tr>

            <tr
              v-for="(item, index) in couseOpen.dataList"
              :key="index"
              v-show="couseOpen.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="couseOpen.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">2.4 在线精品课程选课情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，在线精品课程共计选课人数{{
            getUtils_Fun(onlineBoutique.selectedCourses.value)
          }}人，选课人数最多的课程是{{ courseSelect.MaxArr.schoolname }}的《{{
            courseSelect.MaxArr.name
          }}》，选课人数排名（前十五名）的课程信息如下：
        </p>
        <div class="chart_name">表11 在线精品课选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>级别</th>
              <th>选课人数</th>
            </tr>

            <tr
              v-for="(item, index) in courseSelect.dataList"
              :key="index"
              v-show="courseSelect.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.level }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="courseSelect.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 第九页 -->
      <div class="chart_box page-box">
        <div class="division">3. 视频公开课建设及应用情况</div>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{
            nowDay
          }}日，依据专业与课程服务中心监测平台统计，视频公开课共纳入监测{{
            courseType.videOpen.value
          }}门，其中，国家规范教材有{{ vedioByLevel.FristArr.value }}门、课程思政示范课有{{
            vedioByLevel.SecArr.value
          }}门、公共基础课有{{ vedioByLevel.ThrArr.value }}门、教学能力比赛获奖作品有{{
            vedioByLevel.FouArr.value
          }}门 。目前，视频公开课已有{{ vediOpen.schoolNum.value }}所院校和{{
            vediOpen.tearchNum.value
          }}名教师参与建设与应用；总访问量达{{
            getUtils_Fun(vediOpen.totalVisitNum.value)
          }}次，总开课期数为{{ vediOpen.startsCourses.value }}期，总课时数为{{
            getUtils_Fun(vediOpen.classHour.value)
          }}课时，总选课人数{{ getUtils_Fun(vediOpen.selectedCourses.value) }}人，
          具体建设及应用情况如下：
        </p>
        <h4>3.1 视频公开课建设情况</h4>
        <p>1. 各省视频公开课建设情况</p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共纳入监测{{
            courseType.videOpen.value
          }}门，其中，{{ courseTop.MaxArr.province }}省建设课程数量最多，共{{
            courseTop.MaxArr.total
          }}门，具体各省建设课程数量排名（前十五名）如下表所示：
        </p>
        <div class="chart_name">表12 各省建设课程数量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>省份</th>
              <th>建设课程数</th>
              <th>选课人数</th>
            </tr>

            <tr
              v-for="(item, index) in courseTop.dataList.slice(0, 15)"
              :key="index"
              v-show="courseTop.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.province }}</td>
              <td>{{ item.total }}</td>
              <td>{{ item.studynum }}</td>
            </tr>
            <tr v-show="courseTop.dataList.length == 0" class="nothing">
              <td colspan="5">无</td>
            </tr>
          </table>
        </div>
        <p class="m-top100">2. 归属专业大类分布</p>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，课程覆盖{{
            vedioCourseCategory.dataList.length - 1
          }}个专业大类。从专业大类分布看，{{ vedioCourseCategory.Max.name }}的课程最多，一共{{
            vedioCourseCategory.Max.value
          }}门课程，占比达{{
            ((vedioCourseCategory.Max.value / vedioCourseCategory.total) * 100).toFixed(2)
          }}%，具体可归属专业大类的视频公开课分布如下图所示：
        </p>
        <div class="standards_content echartsHeight">
          <circularChart
            :refId="'typeDistributionChart'"
            :isShowTextColor="true"
            :datas="vedioCourseCategory.dataList"
            :colorName="1"
            :innerText="'数量'"
            :titleLeft="'15%'"
            :legendBackgroundColor="true"
            :circleSize="80"
            :seriesRight="'70%'"
            :showValue="true"
            :unit="'门'"
            :legendLeft="'30%'"
          ></circularChart>
        </div>
        <div class="chart_name">图6 视频公开课专业大类分布情况</div>
      </div>

      <!-- 第十页 -->
      <div class="chart_box page-box">
        <h4>3.2 视频公开课访问情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计访问量{{
            getUtils_Fun(vediOpen.totalVisitNum.value)
          }}，访问量最高的课程是{{ courseVideoPen.MaxArr.schoolname }}的《{{
            courseVideoPen.MaxArr.name
          }}》，访问量排名（前十五名）的课程信息如下：
        </p>
        <div class="chart_name">表13 视频公开课访问量排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>访问量</th>
            </tr>

            <tr
              v-for="(item, index) in courseVideoPen.dataList"
              :key="index"
              v-show="courseVideoPen.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="courseVideoPen.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
        <h4 class="m-top150">3.3 视频公开课选课情况</h4>
        <p>
          截至{{ nowYear }}年{{ nowMonth }}月{{ nowDay }}日，视频公开课共计选课人数{{
            getUtils_Fun(vediOpen.selectedCourses.value)
          }}人，选课人数最多的课程是{{ courseVideoSel.MaxArr.schoolname }}的《{{
            courseVideoSel.MaxArr.name
          }}》，选课人数排名（前十五名）的课程信息如下：
        </p>
        <div class="chart_name">表14 视频公开课选课人数排名（前十五名）</div>
        <div class="biaoge">
          <table
            border="0"
            cellpadding="0"
            cellspacing="0"
            width="100%"
            bordercolor="#fff"
            class="course"
          >
            <tr>
              <th>排名</th>
              <th>课程</th>
              <th>课程负责人</th>
              <th>所属院校</th>
              <th>课程类型</th>
              <th>选课人数</th>
            </tr>

            <tr
              v-for="(item, index) in courseVideoSel.dataList"
              :key="index"
              v-show="courseVideoSel.dataList.length > 0"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.teacher }}</td>
              <td>{{ item.schoolname }}</td>
              <td>{{ item.courseclass }}</td>
              <td>{{ item.num }}</td>
            </tr>
            <tr v-show="courseVideoSel.dataList.length == 0" class="nothing">
              <td colspan="6">无</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import circularChart from "@/components/chart/circularChart.vue"; // 引入圆形图表
import vcolumnarChart from "@/components/chart/vcolumnarChart.vue"; // 引入竖柱状图图表
import tcolumnarChart from "@/components/chart/tcolumnarChart.vue"; // 引入横柱图图表
import discountChart from "@/components/chart/discountChart.vue"; // 引入折线图图表
import waterDropChart from "@/components/chart/waterDropChart.vue"; // 引入水滴图图表
import distributionChart from "@/components/chart/distributionChart.vue"; // 地图
import pageToPDF from "@/utils/htmlToPdf.js";
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart,
  },
  data() {
    return {
      completeNum: 0, //统计接口数量
      year: "",
      colorList: [
        "#3B85FB",
        "#FD398E",
        "#8B68F1",
        "#EE6F5E",
        "#E0D35F",
        "#5470C6",
        "#DE7E4B",
        "#DE524B",
      ], // 柱状图或折线图的颜色
      loading: "", // 是否导出加载中
      // 查询精品课和公开课的数量
      courseTotal: {
        onlineBoutique: null,
        openVedio: null,
      },
      // 视频公开课在线精品课数据总计
      BoutiAndque: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {},
        startsCourses: {},
        classHour: {},
        interactionsTotal: {},
        units: {},
        selectedCourses: {},
      },
      platformNum: {}, //平台数
      // 精品课数据
      onlineBoutique: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {},
        startsCourses: {},
        classHour: {},
        interactionsTotal: {},
        units: {},
        selectedCourses: {},
      },
      // 公开课数据
      vediOpen: {
        tearchNum: {},
        totalVisitNum: {},
        schoolNum: {},
        startsCourses: {},
        classHour: {},
        interactionsTotal: {},
        units: {},
        selectedCourses: {},
      },
      // 视频公开课，在线精品课的数据总和
      vedioAopen: {
        tearchNumTotal: {},
        totalVisitNumTotal: {},
        schoolNumTotal: {},
      },
      // 课程类型分布
      courseType: {
        dataList: [],
        courseTotal: {},
        onlineQualitr: {},
        videOpen: {},
      },

      // 课程表格排名
      courseRankTable: {
        dataList: [],
        Max: {},
      },
      //
      courseNum: {
        dataList: [],
        transverseData: [],
        Frist: {},
        Second: {},
      },
      // 课程总访问量
      courseRankall: {
        dataList: [],
        Max: {},
      },
      // 各省课程访问量
      provinceVisitRank: {
        dataList: [],
        Max: {},
      },
      // 课程选课情况
      courseStudyRank: {
        dataList: [],
        Max: {},
      },
      // 各省课程访问情况
      provinceStudyRank: {
        dataList: [],
        Max: {},
      },
      // 课程互动情况
      courseSemesterRank: {
        dataList: [],
        Max: {},
      },
      // 各省课程互动情况
      provinceSemesterRank: {
        dataList: [],
        Max: {},
      },

      // 区间内在线精品课程访问情况
      selectCourseOnlineVisit: {
        dataList: [],
        VisitTotal: null,
      },
      // 区间内视频公开课访问情况
      selectCourseVediOpenVisit: {
        dataList: [],
        VisitTotal: null,
      },

      // 区间内访问总数据
      SelectVisitData: {
        VisitTotal: null,
        dataList: [],
        legendList: [],
        transverseData: [],
      },

      // 在线精品课 课程级别
      ByLevel: {
        dataList: [],
        total: null,
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {},
      },
      // 视频公开课 课程级别
      vedioByLevel: {
        dataList: [],
        FristArr: {},
        SecArr: {},
        ThrArr: {},
        FouArr: {},
        FouArr: {},
      },
      // 在綫精品課平台数
      Platform: {
        total: null,
      },
      // 视频公开课平台数
      vedioPlatform: {
        total: {},
      },
      // 在线精品课课建设情况
      getonlineCreateRank: {
        dataList: [],
        Total: null,
        Max: {},
      },

      // 在线精品课专业课程大类分布
      onlineCourseCategory: {
        dataList: [],
        total: null,
        Max: {},
      },
      // 课程访问量排名
      couseAll: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      couseRank: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      // 课程访问量排名倒序
      couseAllDesc: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程开课期数
      couseOpen: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      // 课程开课期数
      couseOpenLessTwo: {
        dataList: [],
        MaxArr: [],
        total: null,
      },
      // 课程选课人次排名
      courseSelect: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      courseSelectReaduce: {
        dataList: [],
      },
      // 视频公开课_参建课程数量排名
      courseTop: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      // 视频公开课 专业大类
      vedioCourseCategory: {
        dataList: [],
        Max: {},
        total: null,
      },

      // 视频公开课访问情况
      courseVideoPen: {
        dataList: [],
        MaxArr: {},
        total: null,
      },
      // 视频选课
      courseVideoSel: {
        dataList: [],
        MaxArr: {},
        total: null,
      },

      // 现在的时间
      nowMonth: null,
      nowDay: null,
      type: null,
      nowYear: null,
      Quarter: null,
      detailTime: "",
      startDay: "",
      endDay: "",
      flotNumber: 0,
    };
  },
  created() {
    if (this.$route.query) {
      let token = this.$route.query.token;
      this.startDay = this.$route.query.startDay;
      this.endDay = this.$route.query.endDay;
      this.nowYear = this.endDay.slice(0, 4);
      if (this.startDay.indexOf("01-01") !== -1 && this.endDay.indexOf("03-31") !== -1) {
        this.Quarter = "第1季度";
        this.detailTime = "季度";
      } else if (this.startDay.indexOf("04-01") !== -1 && this.endDay.indexOf("06-30") !== -1) {
        this.Quarter = "第2季度";
        this.detailTime = "季度";
      } else if (this.startDay.indexOf("07-01") !== -1 && this.endDay.indexOf("09-30") !== -1) {
        this.Quarter = "第3季度";
        this.detailTime = "季度";
      } else if (this.startDay.indexOf("10-01") !== -1 && this.endDay.indexOf("12-31") !== -1) {
        this.Quarter = "第4季度";
        this.detailTime = "季度";
      } else if (
        this.$route.query.startDay.indexOf("01-01") !== -1 &&
        this.$route.query.endDay.indexOf("06-30") !== -1
      ) {
        this.Quarter = "上半年";
        this.detailTime = "半年度";
      } else {
        this.detailTime = "年度";
      }

      sessionStorage.setItem("lrmv2token", token);
      let zykid = this.$route.query.zykid;
      sessionStorage.setItem("zykId", zykid);
    }

    this.nowDate();
    this.getcourseReportTotal(); //     获取在线精品课和视频公开课的数量
    this.getOnlineBoutiAndqueHandler(); //     全部总览
    this.getPlatFormNumByType_fn();
    this.getOnlineBoutiqueHandler(); //     在线精品课数据总览
    this.getVediOpenHandler(); //     视频公开课数据总览

    this.courseTypeHandler();
    this.courseRankHandler(); //    具体各省份参与课程建设数量排名（前十名）
    this.courseTearcherHandler(); //    省份参与课程建设教师数量排名（前十名）
    this.courseRankallHandler(); //    课程总访问量
    this.provinceVisitRankHandler(); //    各省课程访问情况
    this.courseStudyRankHandler(); //    课程选课情况
    this.provinceStudyRankHandler(); //    各省选课人数

    this.courseSemesterRankHandler(); //    课程互动情况排名
    this.provinceSemesterRankHandler(); //    各省课程互动情况

    this.selectCourseOnlineVisitHandler(); //    区间内在线精课新增访问趋势

    // 2. 在线精品课应用分析
    this.ByLevelHandler(); //    在线精品课课课程级别
    this.PlatformHandler(); //    获取平台数
    this.getonlineCreateRankHandler(); //    在线精品课课程建设情况
    this.flotNumberHandler();
    this.onlineCourseCategoryHandler(); //    在线精品课专业课程大类分布情况
    this.courseAlltalk(); //    课程访问量排名
    this.courseAlltalkDesc(); //    课程访问量排名倒序
    this.courseProvinceRank();
    this.couseOpenHandler(); //    课程开课期数
    this.courseSelection(); //    课程选课人次排名

    this.vedioByLevelHandler(); //    视频公开课课程级别
    this.vedioPlatformHandler(); //    视频公开课平台数
    this.courseTopHandler();
    this.vedioCourseCategoryHandler();

    this.courseVideoPenHandler();
    this.courseVideoSelHandler();
  },
  watch: {
    completeNum(val) {
      console.log(val);
    },
  },
  methods: {
    // 截取当前日期的赋值操作
    nowDate() {
      let Frist = this.endDay.indexOf("-") + 1;
      let last = this.endDay.lastIndexOf("-") + 1;
      let regx = /^[0]+/;
      this.nowMonth = this.endDay.slice(Frist, last - 1).replace(regx, "");
      this.nowDay = this.endDay.slice(last, this.endDay.length);
    },

    // 转化数字
    getUtils_Fun(num) {
      const data =
        num > 100000000
          ? `${
              (num / 100000000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 100000000).toFixed(0)
                : (num / 100000000).toFixed(2)
            }亿`
          : num > 10000
          ? `${
              (num / 10000).toFixed(2).toString().split(".")[1] === "00"
                ? (num / 10000).toFixed(0)
                : (num / 10000).toFixed(2)
            }万`
          : num;
      return data;
    },

    // 导出pdf文件
    exportPdf() {
      const lableList = document.getElementsByClassName("page-box");
      pageToPDF(
        `${this.nowYear}在线精品课和视频公开课季度分析报告_${this.Quarter}`,
        this.$refs.pdfContent,
        lableList
      );
    },

    // 查询精品课和公开课的数量
    getcourseReportTotal() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportTotal, {
          loading: false,
        })
        .then((res) => {
          let value = Object.values(res.data);
          this.courseTotal.onlineBoutique = value[0];
          this.courseTotal.openVedio = value[1];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 数据总量
    getOnlineBoutiAndqueHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportOverview, 3, {
          loading: false,
        })
        .then((res) => {
          let datas = [];
          for (let i = 0; i < res.data.value.length; i++) {
            datas.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.BoutiAndque.schoolNum = datas.find((item) => item.name == "参建院校");
          this.BoutiAndque.tearchNum = datas.find((item) => item.name == "教师参建人次");
          this.BoutiAndque.totalVisitNum = datas.find((item) => item.name == "总访问量");
          this.BoutiAndque.startsCourses = datas.find((item) => item.name == "总开课期数");
          this.BoutiAndque.classHour = datas.find((item) => item.name == "总课时数");
          this.BoutiAndque.interactionsTotal = datas.find((item) => item.name == "累计互动次数");
          this.BoutiAndque.units = datas.find((item) => item.name == "学员所属单位数（个次）");
          this.BoutiAndque.selectedCourses = datas.find((item) => item.name == "总选课人数");
          this.completeNum = this.completeNum + 1;
        });
    },
    // 获取支撑平台数
    getPlatFormNumByType_fn() {
      this.$axios.post(this.$apiurls.getPlatFormNumByType, { loading: false }).then((res) => {
        if (res.code === 200) {
          this.platformNum = res.data;
        }
        this.completeNum = this.completeNum + 1;
      });
    },
    // 在线精品课数据总览
    getOnlineBoutiqueHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportOverview, 1, {
          loading: false,
        })
        .then((res) => {
          let datas = [];
          for (let i = 0; i < res.data.value.length; i++) {
            datas.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.onlineBoutique.schoolNum = datas.find((item) => item.name == "参建院校");
          this.onlineBoutique.tearchNum = datas.find((item) => item.name == "教师参建人次");
          this.onlineBoutique.totalVisitNum = datas.find((item) => item.name == "总访问量");
          this.onlineBoutique.startsCourses = datas.find((item) => item.name == "总开课期数");
          this.onlineBoutique.classHour = datas.find((item) => item.name == "总课时数");
          this.onlineBoutique.interactionsTotal = datas.find((item) => item.name == "累计互动次数");
          this.onlineBoutique.units = datas.find((item) => item.name == "学员所属单位数（个次）");
          this.onlineBoutique.selectedCourses = datas.find((item) => item.name == "总选课人数");
          this.completeNum = this.completeNum + 1;
        });
    },

    // 视频公开课数据总览
    getVediOpenHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportOverview, 2, {
          loading: false,
        })
        .then((res) => {
          let datas = [];
          for (let i = 0; i < res.data.value.length; i++) {
            datas.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.vediOpen.schoolNum = datas.find((item) => item.name == "参建院校");
          this.vediOpen.tearchNum = datas.find((item) => item.name == "教师参建人次");
          this.vediOpen.totalVisitNum = datas.find((item) => item.name == "总访问量");
          this.vediOpen.startsCourses = datas.find((item) => item.name == "总开课期数");
          this.vediOpen.classHour = datas.find((item) => item.name == "总课时数");
          this.vediOpen.interactionsTotal = datas.find((item) => item.name == "累计互动次数");
          this.vediOpen.units = datas.find((item) => item.name == "学员所属单位数（个次）");
          this.vediOpen.selectedCourses = datas.find((item) => item.name == "总选课人数");
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程类型分布
    courseTypeHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportOverview, {
          loading: false,
        })
        .then((res) => {
          this.courseType.dataList.push(
            {
              name: "在线精品课",
              value: res.data.onlineCourseNum,
            },
            {
              name: "视频公开课",
              value: res.data.videoCourseNum,
            }
          );

          this.courseType.dataList.forEach((item) => {
            this.courseType.courseTotal += item.value;
          });
          this.courseType.courseAll = this.courseType.dataList.find(
            (item) => item.name == "资源库总数"
          );
          this.courseType.onlineQualitr = this.courseType.dataList.find(
            (item) => item.name == "在线精品课"
          );
          this.courseType.videOpen = this.courseType.dataList.find(
            (item) => item.name == "视频公开课"
          );
          this.completeNum = this.completeNum + 1;
        });
    },

    // 表格形式的排名
    courseRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportProvinceRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseRankTable.dataList = res.data;
            this.courseRankTable.Max = this.courseRankTable.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 各省份参与课程建设教师数量排名（前十名）
    courseTearcherHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportTearcherRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            let datas = [];
            for (let i = 0; i < res.data.value.length; i++) {
              this.courseNum.dataList.push(res.data.value[i]);
              this.courseNum.transverseData.push(res.data.name[i]);
              datas.push({ name: res.data.name[i], value: res.data.value[i] });
            }

            function Sort(a, b) {
              return b.value - a.value;
            }
            this.courseNum.dataList.sort(Sort);
            this.courseNum.Frist = datas[0];
            this.courseNum.Second = datas[1];
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 课程总访问量排名
    courseRankallHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportVisitRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.courseRankall.dataList = res.data;

            function Sort(a, b) {
              return b.courseTotalVisit - a.courseTotalVisit;
            }
            this.courseRankall.dataList.forEach((item) => {
              if (item.courseName.length > 8) {
                item.courseName = item.courseName.slice(0, 8) + "....";
              }
            });

            this.courseRankall.dataList.sort(Sort);
            this.courseRankall.dataList = this.courseRankall.dataList;
            this.courseRankall.Max = this.courseRankall.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },
    // 各省课程访问排名
    provinceVisitRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportProvinceVisitRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.provinceVisitRank.dataList = res.data;
            this.provinceVisitRank.Max = this.provinceVisitRank.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程选课情况
    courseStudyRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportStudyRank, 3, {
          loading: false,
        })
        .then((res) => {
          console.log(res.data);
          if (res) {
            this.courseStudyRank.dataList = res.data;
            this.courseStudyRank.Max = this.courseStudyRank.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 各省选课情况排名
    provinceStudyRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportProvinceStudyRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.provinceStudyRank.dataList = res.data;
            function Sort(a, b) {
              return b.courseTotalVisit - a.courseTotalVisit;
            }
            this.provinceStudyRank.dataList.sort(Sort);
            this.provinceStudyRank.Max = this.provinceStudyRank.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程互动情况排名
    courseSemesterRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportSemesterRank, 3, {
          loading: false,
        })
        .then((res) => {
          this.courseSemesterRank.dataList = res.data;
          this.courseSemesterRank.Max = this.courseSemesterRank.dataList[0];
          this.completeNum = this.completeNum + 1;
        });
    },
    // 各省课程互动情况
    provinceSemesterRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportProvinceSemesterRank, {
          loading: false,
        })
        .then((res) => {
          if (res) {
            this.provinceSemesterRank.dataList = res.data;
            this.provinceSemesterRank.Max = this.provinceSemesterRank.dataList[0];
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课区间内课程访问情况
    selectCourseOnlineVisitHandler() {
      this.$axios
        .post(
          this.$apiurls.courseReport_getCourseReportRegionVisitsRank,
          { endDay: this.endDay, startDay: this.startDay, type: 1 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.selectCourseOnlineVisit.dataList = res.data.value;
          this.selectCourseOnlineVisit.dataList.forEach((item) => {
            this.selectCourseOnlineVisit.VisitTotal += item;
          });

          // 总数据
          this.SelectVisitData.dataList.push(this.selectCourseOnlineVisit.dataList);
          this.SelectVisitData.legendList.push("在线精品课");
          this.SelectVisitData.transverseData = res.data.name;
          this.completeNum = this.completeNum + 1;
        });
      this.$axios
        .post(
          this.$apiurls.courseReport_getCourseReportRegionVisitsRank,
          { endDay: this.endDay, startDay: this.startDay, type: 2 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.selectCourseVediOpenVisit.dataList = res.data.value;
          this.SelectVisitData.dataList.push(this.selectCourseVediOpenVisit.dataList);
          this.SelectVisitData.legendList.push("视频公开课");
          this.selectCourseVediOpenVisit.dataList.forEach((item) => {
            this.selectCourseVediOpenVisit.VisitTotal += item;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课 课程级别
    ByLevelHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByLevel, 1, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.ByLevel.dataList.push({
              name: res.data.name[i],
              value: res.data.value[i],
            });
            this.ByLevel.total += res.data.value[i];
          }
          this.ByLevel.FristArr = this.ByLevel.dataList[0];
          this.ByLevel.SecArr = this.ByLevel.dataList[1];
          this.ByLevel.ThrArr = this.ByLevel.dataList[2];
          this.completeNum = this.completeNum + 1;
        });
    },

    // 视频公开课 课程级别
    vedioByLevelHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByLevel, 2, {
          loading: false,
        })
        .then((res) => {
          for (let i = 0; i < res.data.value.length; i++) {
            this.vedioByLevel.dataList.push({
              name: res.data.name[i],
              value: res.data.value[i],
            });
          }
          this.vedioByLevel.FristArr = this.vedioByLevel.dataList[0];
          this.vedioByLevel.SecArr = this.vedioByLevel.dataList[1];
          this.vedioByLevel.ThrArr = this.vedioByLevel.dataList[2];
          this.vedioByLevel.FouArr = this.vedioByLevel.dataList[3];
          console.log(this.vedioByLevel, "aaaaaaa");
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课平台数
    PlatformHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 1, {
          loading: false,
        })
        .then((res) => {
          let datas = [];
          for (let i = 0; i < res.data.value.length; i++) {
            datas.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.Platform.total = datas.find((item) => item.name == "平台数").value;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 视频公开课平台数
    vedioPlatformHandler() {
      this.$axios
        .post(this.$apiurls.coursePortrait_getCourseCountByPlatform, 2, {
          loading: false,
        })
        .then((res) => {
          let datas = [];
          for (let i = 0; i < res.data.value.length; i++) {
            datas.push({ name: res.data.name[i], value: res.data.value[i] });
          }
          this.vedioPlatform.total = datas.find((item) => item.name == "平台数").value;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课建设情况
    getonlineCreateRankHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCourseReportProvinceCreateRank, 1, {
          loading: false,
        })
        .then((res) => {
          this.getonlineCreateRank.dataList = res.data.map((item) => {
            let name = item.province;
            let value = item.total;
            return {
              name,
              value,
            };
          });
          this.getonlineCreateRank.Max = this.getonlineCreateRank.dataList[0];
          this.completeNum = this.completeNum + 1;
        });
    },

    flotNumberHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getOnlineCourseTotalPlatformCount, {
          loading: false,
        })
        .then((res) => {
          this.flotNumber = res.data;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课专业课程大类分布情况
    onlineCourseCategoryHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCountryReportCourseCategoryBuild, 1, {
          loading: false,
        })
        .then((res) => {
          this.onlineCourseCategory.dataList = res.data;
          function Sort(a, b) {
            return b.value - a.value;
          }
          this.onlineCourseCategory.dataList.sort(Sort);
          if (res.data[0].name == "其他") {
            this.onlineCourseCategory.Max = res.data[1];
          } else {
            this.onlineCourseCategory.Max = res.data[0];
          }

          res.data.forEach((item) => {
            this.onlineCourseCategory.total += item.value;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程总访问量排名
    courseAlltalk() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseVisitRank,
          { statType: 1, limitNum: 15, sortType: "desc" },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.couseAll.dataList = res.data;
          this.couseAll.MaxArr = this.couseAll.dataList[0];
          this.couseAll.dataList.forEach((item) => {
            if (item.name.length > 8) {
              item.name = item.name.slice(0, 8) + "...";
            }
            this.couseAll.total += item.num;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 在线精品课建设情况
    courseProvinceRank() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseProvinceRank, 1, {
          loading: false,
        })
        .then((res) => {
          this.couseRank.dataList = res.data;
          function Sort(a, b) {
            return b.studynum - a.studynum;
          }
          this.couseRank.dataList.sort(Sort);
          this.couseRank.MaxArr = this.couseRank.dataList[0];
          this.couseRank.dataList.forEach((item) => {
            this.couseRank.total += item.studynum;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程总访问量倒叙排名
    courseAlltalkDesc() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseVisitRank,
          { statType: 1, limitNum: 15, sortType: "asc" },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.couseAllDesc.dataList = res.data;
          this.couseAllDesc.MaxArr = this.couseAllDesc.dataList[0];
          this.couseAllDesc.dataList.forEach((item) => {
            this.couseAllDesc.total += item.num;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程开课期数
    couseOpenHandler() {
      this.$axios
        .post(
          this.$apiurls.provinceReport_getCountryReportCourseSemesterRank,
          { statType: 1, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.couseOpen.dataList = res.data;
          this.couseOpen.MaxArr = this.couseOpen.dataList[0];
          this.couseOpen.total = res.total;
          this.completeNum = this.completeNum + 1;
        });
    },

    // 课程选课人次排名
    courseSelection() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseStudyRank,
          { statType: 1, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseSelect.dataList = res.data;
          this.courseSelect.MaxArr = this.courseSelect.dataList[0];
          this.courseSelect.dataList.forEach((item) => {
            this.courseSelect.total += item.num;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    // 各省参建课程数量排名
    courseTopHandler() {
      this.$axios
        .post(this.$apiurls.provinceReport_getCountryReportCourseProvinceRank, 2, {
          loading: false,
        })
        .then((res) => {
          this.courseTop.dataList = res.data;
          this.courseTop.MaxArr = this.courseTop.dataList[0];
          for (let i = 0; i < res.data.length; i++) {
            this.courseTop.total += res.data[i].studynum;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    // 视频公开课_课程专业大类分布
    vedioCourseCategoryHandler() {
      this.$axios
        .post(this.$apiurls.courseReport_getCountryReportCourseCategoryBuild, 2, {
          loading: false,
        })
        .then((res) => {
          this.vedioCourseCategory.dataList = res.data;

          function Sort(a, b) {
            return b.value - a.value;
          }
          this.vedioCourseCategory.dataList.sort(Sort);
          if (res.data[0].name == "其他") {
            this.vedioCourseCategory.Max = res.data[1];
          } else {
            this.vedioCourseCategory.Max = res.data[0];
          }

          res.data.forEach((item) => {
            this.vedioCourseCategory.total += item.value;
          });
          this.completeNum = this.completeNum + 1;
        });
    },

    courseVideoPenHandler() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseVisitRank,
          { statType: 2, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseVideoPen.dataList = res.data;
          this.courseVideoPen.MaxArr = this.courseVideoPen.dataList[0];

          for (let i = 0; i < res.data.length; i++) {
            this.courseVideoPen.total += res.data[i].num;
          }
          this.completeNum = this.completeNum + 1;
        });
    },

    courseVideoSelHandler() {
      this.$axios
        .post(
          this.$apiurls.coursePortrait_getCourseStudyRank,
          { statType: 2, limitNum: 15 },
          {
            loading: false,
          }
        )
        .then((res) => {
          this.courseVideoSel.dataList = res.data;
          this.courseVideoSel.MaxArr = this.courseVideoSel.dataList[0];

          this.courseVideoSel.dataList.forEach((item) => {
            this.courseVideoSel.total += item.num;
          });
          this.completeNum = this.completeNum + 1;
        });
    },
    changeCity(data) {
      if (data == "北京" || data == "上海" || data == "天津" || data == "重庆") {
        return data + "市";
      } else {
        return data + "省";
      }
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  /* height: 10860px; */
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  /*width: 70%;*/
  /* width: 86.7%;
  margin: 0px auto;
  height: 32880px; */
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 45px;
  font-weight: bold;
  color: #1d244e;
}

.header_titles .monthly {
  font-size: 40px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 40px 0 60px 0;
}

.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 25px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  position: relative;
  clear: both;
  font-weight: bold;
  font-size: 44px;
  color: #1d244e;
  margin: 35px 0;
}
.chart_box,
.catalogue h3 {
  font-weight: 700;
  color: #1d244e;
}

.catalogue h3 {
  margin-bottom: 15px;
  margin-top: 50px;
  font-size: 60px;
  line-height: 40px;
}

.chart_box h3 {
  font-size: 50px;
  margin-bottom: 35px;
}

.chart_box,
.catalogue h4 {
  font-weight: 700;
  font-size: 50px;
  color: #1d244e;
}

.catalogue h4 {
  margin-bottom: 15px;
  margin-top: 50px;
}

.chart_box h4 {
  font-size: 42px;
  margin-bottom: 35px;
  margin-top: 2.125rem;
}

.chart_box,
.catalogue h5 {
  font-weight: 700;
  font-size: 45px;
  color: #1d244e;
}

.catalogue h5 {
  margin-bottom: 15px;
  margin-top: 50px;
  line-height: 40px;
}
.chart_box h5 {
  font-size: 40px;
  margin-bottom: 35px;
}

.chart_box h6 {
  font-weight: 700;
  font-size: 40px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 40px;
  margin-bottom: 15px;
  margin-top: 50px;
}
.chart_box p {
  font-weight: 540 !important;
  font-size: 35px !important;
  text-indent: 2em;
  line-height: 70px;
  color: #272a3f !important;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  /* height: 400px; */
  /* height: 28rem; */
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 25px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  font-weight: 540 !important;
  text-align: center;
  font-size: 32px;
  color: #272a3f;
  clear: both;
  margin-top: 20px;
}

.chart_box .notes {
  margin: 35px 0;
  line-height: 40px;
  font-size: 28px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}
.biaoge {
  height: 720px;
  font-weight: 540 !important;
  width: 97%;
  margin: 0px auto 25px;
  margin-bottom: 25px;
  /* font-size: 16px !important; */
  color: #272a3f !important;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 45px;
  line-height: 45px;
  color: #707f9d;
  font-size: 26px;
}

.course tr:nth-child(2n) {
  background: rgba(11, 201, 212, 0.2);
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: rgba(73, 187, 233);

  color: #566178;
}

.course tr:first-child {
  background: rgb(88, 136, 248);
  color: #fff;
}
::v-deep .el-progress-bar__innerText {
  color: #000;
  font-size: 25px;
}

.HomePage {
  position: relative;
  padding-left: 10%;
  padding-top: 18%;
}

.HomePage #image {
  width: 559px;
  height: 70px;
  background: url("../../../../public/pdf_year.png") no-repeat;
  background-size: 100% 100%;
}

#PdfTitle {
  margin: 36% 0;
  padding: 20px 0px 20px 40px;
  position: relative;
  border-left: 3px solid #729ac0;
}

#FristTitle {
  font-size: 65px;
  font-weight: 700;
  margin-bottom: 40px;
}

#SecondTitle {
  font-size: 65px;
  font-weight: 600;
  margin-bottom: 40px;
}

#ThrendTitle {
  font-size: 50px;
  font-weight: 600;
  margin-bottom: 40px;
}

#FourTitle {
  font-size: 50px;
  font-weight: 700;
  margin-bottom: 40px;
}

#foot {
  display: flex;
}

.HomePage .footBox {
  flex-direction: column;
  display: flex;
  align-items: center;
  font-size: 42px;
  margin-left: 4.5%;
}

.HomePage #foot p {
  margin: 20px 0px;
}

.catalogue {
  position: relative;
  /* padding: 10% 5%; */
  /* margin-top: 300px; */
}

/* 目录级别 */
.catalogue .title {
  text-align: center;
  margin-bottom: 4%;
  font-size: 40px;
}
.top {
  margin-top: 140px;
}
</style>
<style lang="scss" scoped>
.page-box {
  // padding: 7% 0;
  // height: 2740px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  // border: 1px solid red;
  .m-top150 {
    margin-top: 150px;
  }
  .m-top100 {
    margin-top: 100px;
  }
  .biaoge {
    width: 95%;
    margin: 25px auto;
    .course {
      text-align: center;
      margin: 0px 10px;
      tr {
        height: 42px;
        color: #707f9d;
        font-size: 22px;
        &:nth-child(2n) {
          background: #fff;
          color: #566178;
        }
        &:nth-child(2n-1) {
          background: #7ed2ff;
          color: #566178;
        }
      }
    }
  }
}

.catalogue {
  .title {
    text-align: center;
    margin-bottom: 4%;
    font-size: 40px;
  }

  .Second_text {
    padding-left: 1.8em;
  }

  .Thred_text {
    padding-left: 7.69em;
  }

  h5 {
    display: flex;
    align-items: center;

    .dot {
      flex: 1;
      border-top: dotted #1d244e 7px;
      /* 可设置大小，查属性参数dotted可换其他样式 */
      margin: 0 10px;
      /* 用来控制文字与填充线的间隔大小 */
    }
  }
}

.flex-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  & > div {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
}
.right {
  float: right;
  margin-right: 20px;
  font-size: 32px;
}
</style>
